import YesNoQuestionPage from "@components/YesNoQuestionPage"

export default function CarsExperimentingPage() {
  return <YesNoQuestionPage translationKey="carsExperimenting" />
}
